






































































import Vue from "vue";
import LoginDialog from "@/components/dialog/LoginDialog.vue";
import AuthService, { authServiceInstance } from "@/services/AuthService";
import { logout } from "@/router";
import AlertService from "@/services/libs/AlertService";
import { UserData } from "@/types/User";
import { isProd } from "@/services/libs/Utils";
import GdaClient from "@/assets/gda/gda_client_api";

export default Vue.extend({
  name: "Header",
  components: {
    LoginDialog,
  },
  data: function () {
    return {
      isLoginDialogOpen: false,
      isLoggedIn: false,
      hasWritePermission: false,
    };
  },
  mounted() {
    this.isLoggedIn = AuthService.isLoggedIn();
    this.hasWritePermission = AuthService.hasWritePermission();
  },
  watch: {
    $route() {
      this.isLoggedIn = AuthService.isLoggedIn();
      this.hasWritePermission = AuthService.hasWritePermission();
    },
  },
  computed: {
    user(): UserData | undefined {
      return AuthService.getUser();
    },
    canLogin(): boolean {
      return !isProd();
    },
  },
  methods: {
    openGDA() {
      const url =
        process.env.VUE_APP_GDA_URL +
        process.env.VUE_APP_GDA_EXTERNALEAPPLICATIONID;

      ((this as any).$gdaClient as GdaClient)._openGDAPopup();
      ((this as any).$gdaClient as GdaClient)._openGDAPopupUrl(url);
    },
    doLogout() {
      authServiceInstance.logout();
      // show logout message
      AlertService.info("Ausgeloggt");
      logout();
    },
  },
});
